export function getUltravioletRaysOption () {
  const data = []
  const graphicRight = '20%'
  return {
    legend: {
      show: false,
      top: 0,
      itemWidth: 14,
      itemHeight: 9,
      itemGap: 20,
      icon: 'circle',
      textStyle: {
        color: '#FFF',
        fontSize: '0.8rem'
      }
    },
    grid: {
      // left: 10,
      // right: 10,
      top: 10,
      bottom: 20
    },
    tooltip: {
      trigger: 'axis',
      textStyle: {
        fontStyle: '0.63vw' // 文字字体的风格（'normal'，无样式；'italic'，斜体；'oblique'，倾斜字体）
      }
    },
    xAxis: {
      data: data,
      axisTick: { length: 5 },
      axisLine: {
        onZero: false
      },
      axisLabel: {
        color: '#FFF',
        fontSize: '0.9rem'
      }
    },
    yAxis: [
      {
        type: 'value',
        min: 0,
        max: 15,
        splitLine: {
          show: false
        },
        axisLabel: {
          color: '#FFF',
          fontSize: '0.9rem'
        }
      }
    ],
    graphic: [
      {
        type: 'group',
        bounding: 'raw',
        right: graphicRight,
        bottom: '28%',
        z: 100,
        children: [
          {
            type: 'text',
            z: 100,
            style: {
              fill: '#000',
              text: '最弱',
              font: '0.7rem sans-serif'
            }
          }
        ]
      },
      {
        type: 'group',
        bounding: 'raw',
        right: graphicRight,
        bottom: '40%',
        z: 100,
        children: [
          {
            type: 'text',
            z: 100,
            style: {
              fill: '#000',
              text: '弱',
              font: '0.7rem sans-serif'
            }
          }
        ]
      },
      {
        type: 'group',
        bounding: 'raw',
        right: graphicRight,
        bottom: '51%',
        z: 100,
        children: [
          {
            type: 'text',
            z: 100,
            style: {
              fill: '#000',
              text: '中等',
              font: '0.7rem sans-serif'
            }
          }
        ]
      },
      {
        type: 'group',
        bounding: 'raw',
        right: graphicRight,
        bottom: '63%',
        z: 100,
        children: [
          {
            type: 'text',
            z: 100,
            style: {
              fill: '#000',
              text: '强',
              font: '0.7rem sans-serif'
            }
          }
        ]
      },
      {
        type: 'group',
        bounding: 'raw',
        right: graphicRight,
        bottom: '80%',
        z: 100,
        children: [
          {
            type: 'text',
            z: 100,
            style: {
              fill: '#000',
              text: '很强',
              font: '0.7rem sans-serif'
            }
          }
        ]
      }
    ],
    series: [
      {
        type: 'line',
        yAxisIndex: 0,
        smooth: true,
        data: [],
        label: {
          show: false,
          position: 'top',
          fontSize: '0.75rem',
          color: '#FFF'
        },
        markArea: {
          data: [[{
            yAxis: '0',
            itemStyle: {
              color: '#5455ff',
              opacity: 1
            }
          },
          {
            yAxis: '3'
          }], [{
            yAxis: '3',
            itemStyle: {
              color: '#55ff56',
              opacity: 1
            }
          },
          {
            yAxis: '5'
          }], [{
            yAxis: '5',
            itemStyle: {
              color: '#ffff55',
              opacity: 1
            }
          },
          {
            yAxis: '7'
          }], [{
            yAxis: '7',
            itemStyle: {
              color: '#ffa9aa',
              opacity: 1
            }
          },
          {
            yAxis: '10'
          }], [{
            yAxis: '10',
            itemStyle: {
              color: '#ff5555',
              opacity: 1
            }
          },
          {
            yAxis: '15'
          }]]
        }
      }
    ]
  }
}

export function getUltravioletRaysOptionP () {
  const data = []
  const graphicRight = '20%'
  return {
    legend: {
      show: false,
      top: 0,
      itemWidth: 14,
      itemHeight: 9,
      itemGap: 20,
      icon: 'circle',
      textStyle: {
        color: '#FFF',
        fontSize: '0.8rem'
      }
    },
    grid: {
      // left: 10,
      // right: 10,
      top: 10,
      bottom: 20
    },
    tooltip: {
      trigger: 'axis',
      textStyle: {
        fontStyle: '0.63vw' // 文字字体的风格（'normal'，无样式；'italic'，斜体；'oblique'，倾斜字体）
      }
    },
    xAxis: {
      data: data,
      axisTick: { length: 5 },
      axisLine: {
        onZero: false
      },
      axisLabel: {
        color: '#FFF',
        fontSize: '0.9rem'
      }
    },
    yAxis: [
      {
        type: 'value',
        min: 0,
        max: 15,
        splitLine: {
          show: false
        },
        axisLabel: {
          color: '#FFF',
          fontSize: '0.9rem'
        }
      }
    ],
    graphic: [
      {
        type: 'group',
        bounding: 'raw',
        right: graphicRight,
        bottom: '15%',
        z: 100,
        children: [
          {
            type: 'text',
            z: 100,
            style: {
              fill: '#000',
              text: '最弱',
              font: '1rem sans-serif'
            }
          }
        ]
      },
      {
        type: 'group',
        bounding: 'raw',
        right: graphicRight,
        bottom: '32%',
        z: 100,
        children: [
          {
            type: 'text',
            z: 100,
            style: {
              fill: '#000',
              text: '弱',
              font: '1rem sans-serif'
            }
          }
        ]
      },
      {
        type: 'group',
        bounding: 'raw',
        right: graphicRight,
        bottom: '43%',
        z: 100,
        children: [
          {
            type: 'text',
            z: 100,
            style: {
              fill: '#000',
              text: '中等',
              font: '1rem sans-serif'
            }
          }
        ]
      },
      {
        type: 'group',
        bounding: 'raw',
        right: graphicRight,
        bottom: '58%',
        z: 100,
        children: [
          {
            type: 'text',
            z: 100,
            style: {
              fill: '#000',
              text: '强',
              font: '1rem sans-serif'
            }
          }
        ]
      },
      {
        type: 'group',
        bounding: 'raw',
        right: graphicRight,
        bottom: '80%',
        z: 100,
        children: [
          {
            type: 'text',
            z: 100,
            style: {
              fill: '#000',
              text: '很强',
              font: '1rem sans-serif'
            }
          }
        ]
      }
    ],
    series: [
      {
        type: 'line',
        yAxisIndex: 0,
        smooth: true,
        data: [],
        label: {
          show: false,
          position: 'top',
          fontSize: '0.75rem',
          color: '#FFF'
        },
        markArea: {
          data: [[{
            yAxis: '0',
            itemStyle: {
              color: '#5455ff',
              opacity: 1
            }
          },
          {
            yAxis: '3'
          }], [{
            yAxis: '3',
            itemStyle: {
              color: '#55ff56',
              opacity: 1
            }
          },
          {
            yAxis: '5'
          }], [{
            yAxis: '5',
            itemStyle: {
              color: '#ffff55',
              opacity: 1
            }
          },
          {
            yAxis: '7'
          }], [{
            yAxis: '7',
            itemStyle: {
              color: '#ffa9aa',
              opacity: 1
            }
          },
          {
            yAxis: '10'
          }], [{
            yAxis: '10',
            itemStyle: {
              color: '#ff5555',
              opacity: 1
            }
          },
          {
            yAxis: '15'
          }]]
        }
      }
    ]
  }
}
